export const findSupplier = (list, key) => {
  for (var i = 0; i < list.length; i += 1) {
    if (list[i].key === key) {
      return list[i];
    }
  }
  return {};
};

export const parameterAffectPanelPrice = (name) => {
  const affect_panel_size = [
    'board_length',
    'board_width',
    'array_x_qty',
    'array_y_qty',
    'array_spacing_x',
    'rails_left',
    'rails_right',
    'array_spacing_y',
    'rails_top',
    'rails_bottom',
  ];
  return affect_panel_size.indexOf(name) >= 0;
};

export const parameterForceRequote = (name) => {
  const dont_force_requote = ['part_number', 'revision', 'special_instructions'];
  return dont_force_requote.indexOf(name) < 0;
};

export const calculatePanel = (data) => {

  let result = {
    array_up: null,
    array_x : null,
    array_y : null,
  };

  if (!data)
    return result;

  const array_x_qty = parseFloat(data.array_x_qty);
  const array_y_qty = parseFloat(data.array_y_qty);
  const board_length = parseFloat(data.board_length);
  const board_width = parseFloat(data.board_width);

  const ok_panel_lehgth = !isNaN(board_length) && !isNaN(array_x_qty);
  const ok_panel_width = !isNaN(board_width) && !isNaN(array_y_qty);

  //calculate panel size in x axis
  if (ok_panel_lehgth) {
    result.array_x = board_length * array_x_qty;
    const array_spacing_x = parseFloat(data.array_spacing_x) || 0.0;
    const rails_left = parseFloat(data.rails_left) || 0.0;
    const rails_right = parseFloat(data.rails_right) || 0.0;

    result.array_x += (array_x_qty - 1) * array_spacing_x;
    result.array_x += rails_left + (rails_left > 0 ? array_spacing_x : 0.0);
    result.array_x += rails_right + (rails_right > 0 ? array_spacing_x : 0.0);
    result.array_x = Math.round(result.array_x * 100) / 100
  }

  //calculate panel size in y axis
  if (ok_panel_width) {
    result.array_y = board_width * array_y_qty;
    const array_spacing_y = parseFloat(data.array_spacing_y) || 0.0;
    const rails_top = parseFloat(data.rails_top) || 0.0;
    const rails_bottom = parseFloat(data.rails_bottom) || 0.0;

    result.array_y += (array_y_qty - 1) * array_spacing_y;
    result.array_y += rails_top + (rails_top > 0 ? array_spacing_y : 0.0);
    result.array_y += rails_bottom + (rails_bottom > 0 ? array_spacing_y : 0.0)
    result.array_y = Math.round(result.array_y * 100) / 100
  }

  if (ok_panel_lehgth && ok_panel_width) {
    result.array_up = array_x_qty * array_y_qty;
  }

  return result;
};
